package one.healthium.insights.ui.components.items

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import one.healthium.insights.domain.models.ContentEntry
import one.healthium.ui.compose.components.AppButton
import one.healthium.ui.compose.components.AppButtonDefaults
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.gray_2
import one.healthium.ui.compose.theme.gray_3
import androidx.compose.ui.tooling.preview.Preview

@Composable
internal fun ContentTitle(
    modifier: Modifier = Modifier,
    item: ContentEntry.TitleEntry,
    actionButton: String?,
    onActionClicked: () -> Unit,
) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .padding(24.dp)
    ) {
        Text(
            modifier = Modifier.Companion.weight(1f),
            text = item.text,
            style = AppTheme.textStyles.secondary_22_700,
            color = AppTheme.colors.text100,
        )
        if (actionButton != null) {
            AppButton(
                modifier = Modifier.Companion.height(36.dp),
                onClick = onActionClicked,
                colors = AppButtonDefaults.appButtonColors(
                    containerColor = gray_2,
                    contentColor = gray_3,
                )
            ) {
                Text(actionButton, style = AppTheme.textStyles.secondary_14_400)
            }
        }
    }
}

@Composable
@Preview(showBackground = true)
private fun ContentTitlePreview() {
    AppTheme {
        ContentTitle(
            item = ContentEntry.TitleEntry("Title with Action"),
            actionButton = "Action",
            onActionClicked = {},
        )
    }
}